import React from "react";
import { IneligibleScreen } from "../../EligibilityCheckerGeneric/ResultScreens";

interface PostcodeIneligibleScreenProps {
  title: string;
  heading: string;
  body: string;
}
const PostcodeIneligibleScreen: React.FC<PostcodeIneligibleScreenProps> = props => {
  const { title, heading, body } = props;
  return <IneligibleScreen title={title} heading={heading} bodyText={body} hasContactUs={true} />;
};

export default PostcodeIneligibleScreen;
